import { render, staticRenderFns } from "./ServerErrorDialog.vue?vue&type=template&id=5089dbfb&scoped=true&"
import script from "./ServerErrorDialog.vue?vue&type=script&lang=js&"
export * from "./ServerErrorDialog.vue?vue&type=script&lang=js&"
import style0 from "./ServerErrorDialog.vue?vue&type=style&index=0&id=5089dbfb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089dbfb",
  null
  
)

export default component.exports